import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2e60cc93")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-d-flex p-ai-center p-jc-center" }
const _hoisted_3 = { class: "p-my-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Punto di partenza ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "p-text-center" }, " Indica il punto di partenza da dove generalmente il taker inizia il flusso delle consegne. ", -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("small", { class: "p-ml-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }),
  /*#__PURE__*/_createTextVNode(" Cerca e seleziona l'indirizzo di partenza per farlo comparire nella mappa. ")
], -1)
const _hoisted_9 = {
  id: "map",
  ref: "mapEl",
  class: "map"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Fasce orarie ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-car" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Tipologie della zona ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Nessuna tipologia configurata; ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-euro-sign" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Costi personalizzati ")
const _hoisted_17 = { class: "p-d-flex p-ai-end" }
const _hoisted_18 = { class: "p-fluid p-mr-3" }
const _hoisted_19 = { class: "p-d-flex p-jc-center p-mt-3" }
const _hoisted_20 = {
  key: 1,
  class: "p-d-flex p-jc-center p-mt-3"
}
const _hoisted_21 = {
  key: 1,
  class: "p-d-flex p-jc-center p-mb-3"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_AddressAutocomplete = _resolveComponent("AddressAutocomplete")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_ZoneShiftCosts = _resolveComponent("ZoneShiftCosts")!
  const _component_ZoneVehicleData = _resolveComponent("ZoneVehicleData")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_ZonePricingGrid = _resolveComponent("ZonePricingGrid")!
  const _component_ZoneAutocompleteSelect = _resolveComponent("ZoneAutocompleteSelect")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.zone)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, "Zona: " + _toDisplayString(_ctx.zone.name), 1),
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "p-button-danger p-ml-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeZone(_ctx.zone)))
          }, null, 512), [
            [
              _directive_tooltip,
              _ctx.$t('remove'),
              void 0,
              { bottom: true }
            ]
          ])
        ]),
        _createVNode(_component_Fieldset, null, {
          legend: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_AddressAutocomplete, {
                modelValue: _ctx.startAddress,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.startAddress = $event)),
                onSelectedAddress: _ctx.onSelectStartAddress
              }, null, 8, ["modelValue", "onSelectedAddress"]),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, null, 512)
          ]),
          _: 1
        }),
        _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
          legend: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ZoneShiftCosts, {
              entity: _ctx.taker,
              zone: _ctx.zone
            }, null, 8, ["entity", "zone"])
          ]),
          _: 1
        }),
        _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
          legend: _withCtx(() => [
            _hoisted_12,
            _hoisted_13
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ZoneVehicleData, {
              entity: _ctx.taker,
              zone: _ctx.zone,
              showPrice: false
            }, {
              message: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["entity", "zone"])
          ]),
          _: 1
        }),
        (_ctx.zone.custom)
          ? (_openBlock(), _createBlock(_component_Fieldset, {
              key: 0,
              class: "p-mt-3"
            }, {
              legend: _withCtx(() => [
                _hoisted_15,
                _hoisted_16
              ]),
              default: _withCtx(() => [
                _createElementVNode("section", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_FloatLabel, { label: "Costo al Km" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputNumber, {
                          modelValue: _ctx.zone.custom.cost_km_flat,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.zone.custom.cost_km_flat = $event)),
                          mode: "currency",
                          currency: "EUR",
                          class: "small_input"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_ZonePricingGrid, {
                    value: _ctx.zone.custom,
                    config: _ctx.shapePricingConfig
                  }, null, 8, ["value", "config"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_Button, {
                    label: "Ripristina standard zona",
                    icon: "pi pi-replay",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.restoreStandard(_ctx.zone)))
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.zone.custom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_Button, {
                label: "Personalizza Costi",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createCustom(_ctx.zone)))
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
        _createVNode(_component_ZoneAutocompleteSelect, {
          multiple: false,
          onSelectedZones: _ctx.onSelectZone
        }, null, 8, ["onSelectedZones"])
      ]))
}